import React from 'react';
import { CheckIcon, ShieldCheckIcon } from 'lucide-react';
import { PrimaryButton } from './PrimaryButton';
const checkout = 'https://esl-teacher-ready.impultienda.ar/checkout';
export function FinalCTA() {
  const items = ['120 Ready-to-Teach English Lessons', '6 complete resources in one system', '40+ weeks without repeating', 'Every lesson fully structured end to end', 'Grammar, speaking, writing, and assessment included', 'Bonus 1 — 52 Weekly ESL Teaching Themes', 'Bonus 2 — Ultimate ESL Instruction Language Library', 'Bonus 3 — ESL Beginner Support Guide', 'Bonus 4 — 30 Emergency ESL Lessons', 'Bonus 5 — ESL Lesson Finder System', '7-day money-back guarantee', 'Immediate access', 'Pay in your local currency', 'Ready-to-use PDF format'];
  return <>
      <section className="border-y border-line bg-black px-4 py-16 sm:py-20" data-id="element-37">
        <div className="mx-auto max-w-4xl rounded-3xl border border-gold-700/60 bg-charcoal p-8 text-center sm:p-12" data-id="element-38">
          <ShieldCheckIcon className="mx-auto text-gold-300" size={54} data-id="element-39" />
          <h2 className="mt-5 font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-40">
            Complete 7-Day Guarantee
          </h2>
          <div className="mx-auto mt-6 max-w-2xl space-y-4 text-base leading-7 text-stone-300" data-id="element-41">
            <p data-id="element-42">
              Open the complete 6-in-1 teaching system. Explore the 5 bonuses.
              Use the material in your most challenging class this week.
            </p>
            <p className="font-semibold text-white" data-id="element-43">
              If you feel the material is not clear, practical, or useful for
              your teaching needs — contact us within 7 days.
            </p>
            <p className="font-bold text-gold-100" data-id="element-44">
              We will refund 100% of your money. No questions. No forms. No
              complications.
            </p>
            <p className="text-sm text-stone-500" data-id="element-45">
              Because if the material does not deliver the value we promise, we
              do not want to keep your money.
            </p>
          </div>
        </div>
      </section>

      <section className="relative overflow-hidden bg-black px-4 py-20 sm:py-28" data-id="element-46">
        <div className="absolute inset-0 -z-0 bg-[radial-gradient(ellipse_at_center,_rgba(184,134,11,.14),_transparent_58%)]" data-id="element-47" />
        <div className="relative z-10 mx-auto max-w-4xl text-center" data-id="element-48">
          <h2 className="font-display text-3xl font-bold leading-tight text-white sm:text-5xl" data-id="element-49">
            Next Monday you can keep building your lessons from scratch...
            <br data-id="element-50" />
            <span className="gold-text" data-id="element-51">
              Or walk into the classroom with everything ready — from today.
            </span>
          </h2>

          <div className="mx-auto mt-10 max-w-2xl space-y-3 rounded-2xl border border-line bg-charcoal p-7 text-left" data-id="element-52">
            {['No more Sunday nights searching for activities that actually work.', 'No more lessons that feel rushed or improvised.', 'No more students who lose motivation because sessions feel repetitive.', 'No more weekends lost planning instead of living.', 'No more walking in wishing you had prepared more.'].map(item => <p key={item} className="flex gap-3 text-sm text-stone-300" data-id="element-53">
                <span className="text-gold-300" data-id="element-54">▸</span>
                {item}
              </p>)}
          </div>

          <p className="mx-auto mt-9 max-w-2xl text-lg leading-8 text-stone-300" data-id="element-55">
            ESL Teacher Ready™ does not make you a better teacher.{' '}
            <strong className="text-gold-300" data-id="element-56">
              You are already a great teacher.
            </strong>
            <br data-id="element-57" />
            What it does is give you the time and tools to make that visible in
            every class you teach.
          </p>

          <div className="mx-auto mt-10 max-w-2xl rounded-3xl border border-gold-700/50 bg-black p-7 text-left sm:p-10" data-id="element-58">
            <h3 className="border-b border-line pb-5 text-center font-display text-2xl font-bold text-white" data-id="element-59">
              Everything that is included:
            </h3>
            <div className="mt-6 grid gap-3 sm:grid-cols-2" data-id="element-60">
              {items.map(item => <p key={item} className="flex gap-2 text-sm text-stone-300" data-id="element-61">
                  <CheckIcon size={17} className="shrink-0 text-gold-300" data-id="element-62" />
                  {item}
                </p>)}
            </div>
            <p className="mt-8 rounded-xl border border-gold-700/40 bg-gold-700/10 p-5 text-center font-display text-lg italic text-stone-200" data-id="element-63">
              “The best time to have this teaching system was before your very
              first class.{' '}
              <strong className="not-italic text-gold-300" data-id="element-64">
                The second-best time is today.
              </strong>
              ”
            </p>
            <div className="mt-8 text-center" data-id="element-65">
              <p className="font-display text-xl font-bold text-white" data-id="element-66">
                ESL Teacher Ready™
              </p>
              <p className="mx-auto mt-2 max-w-md text-sm leading-6 text-stone-400" data-id="element-67">
                120 ready-to-teach English lessons created to help teachers plan
                less, teach with confidence, and keep every session fresh — from
                A1 to B1.
              </p>
              <PrimaryButton href={checkout} className="mt-7 w-full sm:w-auto" data-id="element-68">
                GET THE COMPLETE 6-IN-1 SYSTEM NOW
              </PrimaryButton>
              <p className="mt-5 text-xs text-stone-500" data-id="element-69">
                7-Day Money-Back Guarantee · Secure Payment · Immediate Access ·
                Pay in Your Local Currency
              </p>
            </div>
          </div>
        </div>
      </section>
    </>;
}